import React from "react";
import { useCart } from "../../context/CartContext";
import { Link } from "react-router-dom";

import { Add, ShoppingCart, Delete, Remove } from "@mui/icons-material";

const CartModal = () => {
  const { getTotalItems } = useCart();

  const {
    cartItems,
    increaseQuantity,
    decreaseQuantity,
    removeFromCart,
    getTotalPrice,
  } = useCart();

  return (
    <div className="relative group inline-block">
      <Link to="/cart" className=" hover:text-white">
        <ShoppingCart fontSize="small" />
        <span className="absolute -top-2 right-0 bg-red-500 text-white rounded-full text-small w-4 h-4 flex items-center justify-center">
          {getTotalItems()}
        </span>
      </Link>

      <div
        className="opacity-0 group-hover:opacity-100 invisible group-hover:visible absolute -left-32 transform -translate-x-1/2
             top-full z-10 w-80  p-4 overflow-y-auto bg-white border border-gray-300 rounded-tl-3xl rounded-br-3xl  shadow-lg transition-opacity duration-300 ease-in-out"
      >
        <div className="cart-arrow"></div>

        <h3 className="text-lg font-semibold border-b-2 border-coffee text-black mb-2">
          Shopping Cart
        </h3>

        {cartItems.length === 0 ? (
          <p className="text-center text-black py-8 ">Your cart is empty.</p>
        ) : (
          <div>
            <ul className=" overflow-y-auto max-h-96">
              {cartItems.map((item) => (
                <li key={item.id} className="mb-4 items-center ">
                  <div className="flex items-center">
                    {item.imageUrls && item.imageUrls.length > 0 && (
                      <img
                        key={item.id}
                        src={item.imageUrls[0]}
                        alt={item.title}
                        className="w-12 h-12 object-cover mr-4"
                      />
                    )}

                    <div className="text-black">
                      <p className="text-small truncate overflow-hidden w-56">
                        {item.name}
                      </p>
                    </div>
                  </div>

                  <div className="text-black flex justify-between font-robo items-center mt-2">
                    <p className="text-small px-6">
                      Gh₵ {item.price.toLocaleString()} + Gh₵{" "}
                      {item.shippingFee.toLocaleString()}
                    </p>

                    <div className="flex text-small items-center text-black font-robo space-x-2">
                      <button
                        onClick={() => decreaseQuantity(item.id)}
                        className="text-white font-bold bg-coffee rounded"
                      >
                        <Remove fontSize="extra small" />
                      </button>

                      <p className="text-small">{item.quantity}</p>

                      <button
                        onClick={() => increaseQuantity(item.id)}
                        className="text-white font-bold bg-coffee rounded"
                      >
                        <Add fontSize="extra small" />
                      </button>

                      <button
                        onClick={() => removeFromCart(item.id)}
                        className="text-red-500"
                      >
                        <Delete fontSize="small" />
                      </button>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
         
              <div className="flex justify-between p-2 items-center text-black mt-4 bg-lightBrown rounded-tl-2xl font-robo font-bold rounded-br-2xl ">
                <h3 className="text-small px-2">Total</h3>
                <h3 className="text-small px-6">
                  Gh₵ {getTotalPrice().toLocaleString()}
                </h3>
              </div>
         
            <div className=" mt-8">
              <Link
                to="/cart"
                className="mt-4 text-small bg-black text-white p-2 rounded hover:text-white"
              >
                View Cart
              </Link>
              <Link
                to="/checkout"
                className="mt-4 ml-2 text-small bg-coffee text-white p-2 rounded hover:text-white"
              >
                Checkout
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CartModal;
